<div class="d-inline-block w-100">
    <div *ngIf="!showChart; else showCanvas" class="d-flex justify-content-center">
        <img alt="no data" src="assets/no_data_image/error-logo.png" class="noDataImage pt-100">
    </div>
    <ng-template #showCanvas>
    <canvas #groupedChartCanvas class="chartWidth" width="400" height="400"></canvas>
</ng-template>
</div>